/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { App } from './App';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from 'react-router-dom';
import { AppRouter } from './router';
import { env } from './config/env';
import { withModeTitlePrefix } from './utils/appMode';

// A development build names its mode in the tab title, e.g. `[DEV] Bos Seller`,
// so tabs on different APIs are told apart at a glance (SEL-66).
document.title = withModeTitlePrefix(document.title, env.modeDisplay);

const elem = document.getElementById('root');

if (!elem) {
    throw new Error('Root element not found');
}
const router = createBrowserRouter(
    createRoutesFromElements(<Route element={<App />}>{AppRouter}</Route>),
);

const app = (
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>
);

const camusWindow = window as Window & { __camusRoot?: Root };

camusWindow.__camusRoot ??= createRoot(elem);
camusWindow.__camusRoot.render(app);
